import { Match } from 'effect';

import { Channel, getDefaultChannel } from '../config/channel';

export default function getLocalizedNavigationSpecialEventsLinks() {
  return Match.value(getDefaultChannel()).pipe(
    Match.when(Channel.CZ_CHANNEL, () => navigationSpecialEventsLinksCZ),
    Match.when(Channel.SK_CHANNEL, () => navigationSpecialEventsLinksSK),
    Match.exhaustive
  );
}

export type NavigationSpecialEventsLinkT = {
  title: string;
  href: string;
};

const navigationSpecialEventsLinksCZ: NavigationSpecialEventsLinkT[] = [
  // {
  //   title: 'Tipy na dárky',
  //   href: Url.presentsTips,
  // },
];

const navigationSpecialEventsLinksSK: NavigationSpecialEventsLinkT[] = [
  // {
  //   title: 'Tipy na darčeky',
  //   href: Url.presentsTips,
  // },
];
